import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { DatetimeFormatType } from 'app/lib/datetime/types';

import Datetime from '../Datetime';

import styles from './Notification.module.scss';

export enum NotificationStatus {
  SUCCESS = 'success',
  DEFAULT = 'default',
}

export type NotificationProps = {
  to?: string;
  title: string;
  body?: ReactNode;
  date: Date;
  status?: NotificationStatus;
  statusContent?: ReactNode;
  className?: string;
  id: number;
  onClick?: () => void;
};

export const Notification: FC<NotificationProps> = ({
  to,
  title,
  body,
  date,
  className,
  status = NotificationStatus.DEFAULT,
  statusContent,
  id,
  onClick,
}) => {
  const showStatus = Boolean(statusContent);

  const rootClassName = classNames(styles.root, { [styles.rootLink]: Boolean(to) }, className);

  const statusClassName = classNames(styles.status, {
    [styles.statusSuccess]: status === NotificationStatus.SUCCESS,
  });

  const content = (
    <>
      <div className={styles.header}>
        <Datetime className={styles.date}
                  value={date}
                  format={DatetimeFormatType.FRIENDLY} />
        {showStatus && (
          <div data-testid="notification-status"
               className={statusClassName}>
            {statusContent}
          </div>
        )}
      </div>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.body}>{body}</div>
    </>
  );

  if (to) {
    return (
      <Link to={to}
            className={rootClassName}
            onClick={onClick}
            data-testid="notification_link"
            data-ga-event="notification_click"
            data-ga-event-content={id}>
        {content}
      </Link>
    );
  }

  return (
    <a onClick={onClick}
       className={rootClassName}>
      {content}
    </a>
  );
};
